import { render, staticRenderFns } from "./OuterCard.vue?vue&type=template&id=dffa12b2&scoped=true&"
import script from "./OuterCard.vue?vue&type=script&lang=js&"
export * from "./OuterCard.vue?vue&type=script&lang=js&"
import style0 from "./OuterCard.vue?vue&type=style&index=0&id=dffa12b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffa12b2",
  null
  
)

export default component.exports